import { MsalProvider } from '@azure/msal-react'
import { DateFnsLocaleProvider } from '@if/core/date'
import i18n, { initializeI18N } from '@if/core/i18n'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import Router from './containers/Router'
import './index.css'
import GlobalLoaderProvider from './providers/GlobalLoaderProvider'
import LocaleProvider from './providers/LocaleProvider'
import NotificationProvider from './providers/NotificationProvider'
import ThemeProvider from './providers/ThemeProvider'
import UserProvider from './providers/UserProvider'
import initializeAppInsights from './services/AppInsights'
import initializeMsal from './services/Authentification'
import { reportErrorToConsole, setupTracking } from './services/error-logger'

const ai = initializeAppInsights()
setupTracking(ai)

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, refetchOnReconnect: false } },
})
const container = document.getElementById('root')
const root = createRoot(container!)
const msalInstance = initializeMsal()

initializeI18N()
  .then(() => {
    root.render(
      <I18nextProvider i18n={i18n}>
        <MsalProvider instance={msalInstance}>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider>
              <DateFnsLocaleProvider>
                <LocaleProvider>
                  <NotificationProvider>
                    <UserProvider>
                      <GlobalLoaderProvider>
                        <Router />
                        <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
                      </GlobalLoaderProvider>
                    </UserProvider>
                  </NotificationProvider>
                </LocaleProvider>
              </DateFnsLocaleProvider>
            </ThemeProvider>
          </QueryClientProvider>
        </MsalProvider>
      </I18nextProvider>,
    )
  })
  .catch(reportErrorToConsole)
